import React, { useRef, useEffect } from 'react';
import './Carousel3D.css';
import foto1 from '../images/eq1.png';
import foto2 from '../images/eq2.png';
import foto3 from '../images/eq3.png';
import foto4 from '../images/eq4.png';
import foto5 from '../images/eq5.jpg';

const originalImages = [
  { src: foto1, title: 'ORTODONCISTA' },
  { src: foto2, title: 'CIRUJANO MAXILOFACIAL' },
  { src: foto3, title: 'ENDODONCISTA' },
  { src: foto4, title: 'ODONTOPEDIATRIA' },
  { src: foto5, title: 'CIRUJANO BUCAL' }
];

const carouselImages = [...originalImages, ...originalImages];

const Carousel3D = () => {
  const itemsRef = useRef([]);

  useEffect(() => {
    let animationFrameId;

    const update3DEffect = () => {
      const screenCenter = window.innerWidth / 2;

      itemsRef.current.forEach((element) => {
        if (!element) return;

        const rect = element.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;

        const diff = itemCenter - screenCenter;

        const maxRotation = 45; 
        const rotationY = (diff / screenCenter) * -maxRotation;

        const maxScaleDistance = screenCenter;
        const scale = Math.max(0.75, 1 - Math.abs(diff) / maxScaleDistance * 0.25);

        element.style.transform = `perspective(1000px) rotateY(${rotationY}deg) scale(${scale})`;
      });

      animationFrameId = requestAnimationFrame(update3DEffect);
    };

    update3DEffect();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {carouselImages.map((item, index) => (
          <div
            key={index}
            className="carousel-item"
            ref={(el) => (itemsRef.current[index] = el)}
          >
            {/* Usamos item.src e item.title */}
            <img src={item.src} alt={`Carrusel ${index + 1}`} />
            <div className="carousel-title">
              {item.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel3D;